import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { deleteReply } from "./schema/delete-reply";
import { getReviewById } from "./schema/get-review-by-id";
import { getReviews } from "./schema/get-reviews";
import { getReviewsAverageByProject } from "./schema/get-reviews-average-by-project";
import { getReviewsByProductId } from "./schema/get-reviews-by-product-id";
import { generateGoogleReviewFeed } from "./schema/google-feed/generate-google-review-feed";
import { getGoogleReviewFeedUrl } from "./schema/google-feed/get-google-review-feed-url";
import { updateGoogleFeedSettings } from "./schema/google-feed/update-google-feed-settings";
import { publishUnpublishReview } from "./schema/publish-unpublish-review";
import { createReviewForm } from "./schema/review-form/create-review-form";
import { getActiveReviewFormForTeam } from "./schema/review-form/get-active-review-form-for-team";
import { updateReviewForm } from "./schema/review-form/update-review-form";
import { sendReviewEditEmail } from "./schema/send-review-edit-email";
import { getOrCreateStarRatingWidget } from "./schema/star-rating-widget/get-or-create-star-rating-widget";
import { updateStarRatingWidget } from "./schema/star-rating-widget/update-star-rating-widget";
import { updateCollectionReviewSettings } from "./schema/update-collection-review-settings";
import { updateReview } from "./schema/update-review";

export const rpcDefinition = {
  createReviewForm,
  deleteReply,
  updateReviewForm,
  getActiveReviewFormForTeam,
  getReviewsByProductId,
  getReviewById,
  getReviews,
  updateReview,
  publishUnpublishReview,
  getReviewsAverageByProject,
  getOrCreateStarRatingWidget,
  updateStarRatingWidget,
  updateCollectionReviewSettings,
  sendReviewEditEmail,
  getGoogleReviewFeedUrl,
  generateGoogleReviewFeed,
  updateGoogleFeedSettings,
};

export type RedoReviewsRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
